<nav *ngIf="totalPages > 0">
  <ul class="pagination">
    <li class="page-item" [ngClass]="{ disabled: !canGoPrevious }">
      <a class="page-link" (click)="goToPreviousPage()">Previous</a>
    </li>

    <ng-container *ngFor="let p of visiblePages; let i = index">
      <li class="page-item" [ngClass]="{ active: currentPage === p }">
        <a class="page-link" (click)="navigatePage(p)">{{p}}</a>
      </li>

      <li class="page-item disabled" *ngIf="showEllipsisAfter(i)">
        <span class="page-link">...</span>
      </li>
    </ng-container>

    <li class="page-item" [ngClass]="{ disabled: !canGoNext }">
      <a class="page-link" (click)="goToNextPage()">Next</a>
    </li>
  </ul>
</nav>